module.exports = __webpack_public_path__ + "img/ill_calendar.bcd33713.svg";